import {Injectable} from '@angular/core';
import {isEmpty} from 'lodash';
import {ERROR_CODES} from 'src/app/domain/error/error-codes';
import ValidationError from 'src/app/domain/error/validation-error';
import {isLegalNif} from 'src/app/domain/function/nif/legal-entity-nif.helper';
import {isPhysicalNif} from 'src/app/domain/function/nif/physical-entity-nif.helper';
import {AbstractValidator} from 'src/app/domain/validators/validator';

@Injectable({
  providedIn: 'root'
})
export class VatValidator extends AbstractValidator {

  isValid(value: string | null): boolean {
    return super.isValid(value);
  }

  validate(value: string | null): void {
    if (isEmpty(value)) {
      return;
    }

    if (isPhysicalNif(value.toUpperCase()) || isLegalNif(value.toUpperCase())) {
      return;
    }

    throw new ValidationError(ERROR_CODES.invalidVat, 'shared.errors.invalidVat');
  }
}
